import styles from "./MainLayout.module.scss";
import {Outlet} from "react-router-dom";
import Header from "../Header/Header";
import {useEffect} from "react";
import {TrainersService} from "../../services/trainers.service";
import {setTrainers} from "../../store/trainers/trainersSlice";
import {ClassesService} from "../../services/classes.service";
import {setClasses} from "../../store/classes/classesSlice";
import {PlansService} from "../../services/plans.service";
import {setPackages} from "../../store/package/packageSlice";
import useAppDispatch from "../../hooks/useAppDispatch";
import useAppSelector from "../../hooks/useAppSelector";
import Footer from "../Footer/Footer";

const MainLayout = () => {
    const dispatch = useAppDispatch();

    const {activeGym} = useAppSelector(state => state.multiGymsSlice);

    useEffect(() => {
        getClasses();
        getTrainers();
        getPackages();
    }, [activeGym]);

    // check active gyms

    const getTrainers = async () => {
        try {
            const response = await TrainersService.getTrainers();
            if (response.data && response.status === 200) {
                dispatch(setTrainers(response.data));
            }
        } catch (e) {
        }
    }

    const getClasses = async () => {
        try {
            const response = await ClassesService.getClasses();
            if (response.data && response.status === 200) {
                dispatch(setClasses(response.data));
            }
        } catch (e) {
        }
    }

    const getPackages = async () => {
        try {
            const response = await PlansService.getAllPackage();
            if (response.data && response.status === 200) {
                dispatch(setPackages(response.data));
            }
        } catch (e) {
        }
    }

    return (
        <>
            <Header/>
            <main className={styles.content}>
                <Outlet/>
            </main>
            <Footer/>
        </>
    )
}

export default MainLayout;